export default __webpack_public_path__ + "static/media/USD.876b9dc4.bin";